var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"775b4c46fa736f29f37afff6e51d25e4b3916bf8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["spoox@play-inc"]={id:"775b4c46fa736f29f37afff6e51d25e4b3916bf8"};
      